export function transactionLabel(transaction) {
  if (transaction.user_label === 'gift') return 'Gift';
  if (transaction.transaction_nature) return transaction.transaction_nature;
  return Number(transaction.amount) > 0 ? 'income' : 'expense';
}
